import styled, { css } from 'styled-components'

import breakpoints from '../../theme/breakpoints'
import Icon from '../Icon'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;

  ${breakpoints.up('tablet')} {
    gap: 4rem;
  }
`

export const StepName = styled.p`
  ${({ theme }) => theme.textStyles.textSmall}
  color: ${({ theme }) => theme.colors.nightRider};
  margin-bottom: 0.8rem;
  text-align: center;
`

export const FakeIcon = styled.div`
  position: absolute;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  z-index: 2;
  bottom: 0;
`

export const StepIcon = styled(Icon)`
  width: 4.8rem;
  height: 4.8rem;
  color: ${({ theme }) => theme.colors.nightRider};
  z-index: 3;
`

export const Step = styled.div<{ $active?: boolean; $completed?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  ${({ $active, theme }) =>
    $active &&
    css`
      ${StepName} {
        ${theme.textStyles.textSmallStrong}
        color: ${theme.colors.royalBlue};
      }
      ${StepIcon} {
        color: ${theme.colors.royalBlue};
      }
    `}

  ${({ $completed, theme }) =>
    $completed &&
    css`
      ${StepIcon} {
        color: ${theme.colors.nightRider};
      }
    `}


  // Connector segments: each step draws a half-line from its (centered) icon to
  // the midpoint of the gap on each side (::after = right, ::before = left).
  // Adjacent half-lines meet at the gap midpoint, so the line connects cleanly
  // regardless of each step's label width. Width = 50% (icon centre → step edge)
  // + half the container gap.
  &::after,
  &::before {
    content: '';
    height: 0.2rem;
    width: calc(50% + 1rem);
    background-color: ${({ theme }) => theme.colors.nightRider};
    position: absolute;
    bottom: 2.2rem;
    z-index: 1;

    ${breakpoints.up('tablet')} {
      width: calc(50% + 2rem);
    }
  }

  &::after {
    left: 50%;
  }

  &::before {
    right: 50%;
  }

  &:first-child::before,
  &:last-child::after {
    display: none;
  }
`
